import { render } from "./EntityPriorityODSComponent.vue?vue&type=template&id=a687b69a"
import script from "./EntityPriorityODSComponent.vue?vue&type=script&lang=js"
export * from "./EntityPriorityODSComponent.vue?vue&type=script&lang=js"

import "./EntityPriorityODSComponent.vue?vue&type=style&index=0&id=a687b69a&lang=scss"
script.render = render

export default script